var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"iconTextColor--text",attrs:{"small":"","text":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{staticClass:"pr-1",attrs:{"medium":""}},[_vm._v(" "+_vm._s(_vm.bIcon))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }